export default function isBrowserIE(): boolean {
  const userAgent = window.navigator.userAgent
  return (userAgent.indexOf('MSIE') >= 0) || !!userAgent.match(/Trident\/\d+\./)
}
